import { setAnalyticsProvider, useAppSettings } from "@next-platform/client-common-core";
import { useEffect, useState } from "react";

import AnalyticsProvider from "@/utils/analyticsProvider";

type UseGoogleAnalyticsInitReturn = {
  isAnalyticsInitialized: boolean;
};

const useGoogleAnalyticsInit = (): UseGoogleAnalyticsInitReturn => {
  const appSettings = useAppSettings();
  const googleAnalyticsId = appSettings?.googleAnalyticsId;
  const [stateIsAnalyticsInitialized, setStateIsAnalyticsInitialized] = useState(false);

  useEffect(() => {
    if (!googleAnalyticsId) {
      return;
    }

    const analytics = AnalyticsProvider.getInstance(googleAnalyticsId);
    if (analytics) {
      setAnalyticsProvider(analytics);
      setStateIsAnalyticsInitialized(true);
    }
  }, [googleAnalyticsId]);

  return { isAnalyticsInitialized: stateIsAnalyticsInitialized };
};

export default useGoogleAnalyticsInit;
